import React, { Component } from 'react'

import './numpad.scss'

// elements
import Icon from '../icon'
import { NumPadIcons } from '../icons'

class NumPad extends Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.onClick = this.onClick.bind(this)
  }

  onClick (val) {
    if (this.props.onClick !== null) {
      this.props.onClick(val)
    }
  }

  render () {
    return (
      <div className='element-numpad'>
        <span onClick={this.onClick.bind(this, '1')}>{1}</span>
        <span onClick={this.onClick.bind(this, '2')}>{2}</span>
        <span onClick={this.onClick.bind(this, '3')}>{3}</span>
        <span onClick={this.onClick.bind(this, '4')}>{4}</span>
        <span onClick={this.onClick.bind(this, '5')}>{5}</span>
        <span onClick={this.onClick.bind(this, '6')}>{6}</span>
        <span onClick={this.onClick.bind(this, '7')}>{7}</span>
        <span onClick={this.onClick.bind(this, '8')}>{8}</span>
        <span onClick={this.onClick.bind(this, '9')}>{9}</span>
        <span />
        <span onClick={this.onClick.bind(this, '0')}>{0}</span>
        <span onClick={this.onClick.bind(this, 'delete')}><Icon icon={NumPadIcons.Delete_Red} /></span>
      </div>
    )
  }
}

export default NumPad



// WEBPACK FOOTER //
// ./src/app/shared/elements/numPad/index.js